/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![StarOutlineIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACBElEQVR4nOVUv2sUQRSOICKCoqJgZyCl2CnBxkP8wZHb9763ktn37oRcI2rnP6BgZSWIXaoUlnaJhUGbEEg6MdqJYCGCikHsjD+iMnO7e3tLQnZhG3HgwTDzzfvej+/N2Nh/s5h5P8Oek+iLdvvKgcYJgO5VFvvjjUSvNU7A0CcFgsVGnQP9gwT7zmI/vRH0R6fTO9QYAXMyE6KHPiWxZ2HPyUxjBCQ6750C3essdiMt03zNKO0Ux+rKBqgy9BtBN6ecO+bN7/1ZuNviTRQnp0ecR9DzWQO3MxJbHmZkyzvhI9FLxegnQ1QZALrKsEcjxjZdwE+X70lsJQ8GuhlJ90ypRMk5Fns/ANhXn36NHoGg6wMC/UixtbcERlH3CIkuFFJ9GEXRvu0ct/r9vQR9wGK/M5X5Hu0U0C4WvcliG6laXgE6XgZNXe4dZ9GXaSAb/o1/WzXr0JcsExGdKN/7szxTtsnKjnOC2DqDtG0tO3POHfaWY2BrARNbpzYBic2lEd4qZPSWxN4xJ2cDBno7lfBcLeetVms3i34Oj8lO+Pr6/2coQ/tF0DtA72SqnC/OuT2VCZiTC6me1xm6lGmboXe95TMDXcrkSbFdrFEenR2dTB3RdnFmCl/4bHUC2OvhVNvjtnNHyxh/5u8KJG8qE7DoPYZ9qKDtMDME/cSi9ysT/FPrL9VKTCj6YtxwAAAAAElFTkSuQmCC)
 */
export const StarOutlineIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M2.07 10.94a1.25 1.25 0 0 1 .73-2.25h6.12l1.9-5.83c.37-1.15 2-1.15 2.37 0l1.89 5.83h6.12c1.2 0 1.71 1.54.73 2.25l-4.95 3.6 1.9 5.82a1.25 1.25 0 0 1-1.93 1.4L12 18.16l-4.95 3.6c-.98.7-2.3-.25-1.92-1.4l1.89-5.82-4.95-3.6Zm11.55-.25h5.26l-4.25 3.09 1.62 5-4.25-3.1-4.25 3.1 1.62-5-4.25-3.1h5.26l1.62-5 1.62 5Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
